import React, { useState, useEffect } from "react";
import { Routes, Route, useLocation, useNavigate } from "react-router-dom";
import SideBar from "../../components/sideBar/SideBar";

import Header from "../../components/header/Header";
import TemplateList from "../../components/templatelist/TemplateList";
import Cvthemeone from "../../components/templates/Cvthemeone";
import Templatee from "../../components/templates/Templatee";
import StylishResume from "../../components/templates/StylishResume";
import Template from "../../components/templates/Template";
import Template2 from "../../components/templates/Template2";
import Template3 from "../../components/templates/Template3";
import Draft from "../../pages/draft/Draft";
import Editor from "../../components/templates/Editor";
import "./Dashboard.css";
import ResumeScore from "../resumescrore/ResumeScore";

function DashBoard() {
  const location = useLocation();
  const navigate = useNavigate();
  const [showTemplateList, setShowTemplateList] = useState(false);

  // Redirect to Editor page when user logs in
  useEffect(() => {
    if (location.pathname === "/dashboard") {
      navigate("/dashboard/templatelist/editor", { replace: true });
    }
  }, [location.pathname, navigate]);

  // Update showTemplateList based on the current route
  useEffect(() => {
    setShowTemplateList(location.pathname.startsWith("/dashboard/templatelist"));
  }, [location.pathname]);

  return (
    <div className="dashboard-layout">
      {/* Main Sidebar */}
      <SideBar setShowTemplateList={setShowTemplateList} />

      {/* Show Template List ONLY when in "Templates" section */}
      {showTemplateList && <TemplateList />}

      {/* Main Content */}
      <div className="main-content">
        <Header />
        <div className="dashboard-content">
          <Routes>
            {/* Template Routes */}
            <Route path="templatelist/template1" element={<Template />} />
            <Route path="templatelist/template2" element={<Template2 />} />
            <Route path="templatelist/template3" element={<Template3 />} />
            <Route path="templatelist/cvthemeone" element={<Cvthemeone />} />
            <Route path="templatelist/stylishresume" element={<StylishResume />} />
            <Route path="templatelist/template6" element={<Templatee />} />
            <Route path="templatelist/editor" element={<Editor />} />

            {/* Other Sections */}
            <Route path="draft" element={<Draft />} />
            <Route path="resumescorer" element={<ResumeScore />} />
          </Routes>
        </div>
      </div>

     
     
    </div>
  );
}

export default DashBoard;
